import React, {useState} from 'react';
import classNames from "classnames";
import {Link} from "react-router-dom";
import MyRoute from "../../route"

import './index.css';

export const MyDrawer = ({ open, handleRoute }) => {
  const [active, setActive] = useState('')

  const handleActive = item => {
    setActive(item)
    handleRoute(item)
  }

  return (
    <div className={classNames('drawer-wrapper', open ? 'drawer-close' : 'drawer-open')}>
      {MyRoute.map((item, index) => {
       return (
         <Link key={index} className="drawer-link" to={`/${item.link}`}>
           <div className={classNames('drawer-item-box',item.link === active && 'drawer-box-active' )}>
            <img
              onClick={() => handleActive(item.name)}
              className={classNames('drawer-image', item.name === active && 'drawer-image-active')}
              src={item.image} alt={item.name}
            />
             <span
               key={item.name}
               data-nav={item.name}
               onClick={() => handleActive(item.name)}
               className={classNames('drawer-box', open && 'drawer-box-hide',item.name === active && 'drawer-label-active')}
             >
            {item.name}
           </span>
           </div>
         </Link>
       )
      })}
    </div>
  )
}